import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home'
import SignIn from './components/SignIn'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Sign-In',
      component: SignIn
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    }
  ]
})
